module.exports = __webpack_public_path__ + "img/pr-13.d8837e77.png";